import * as React from 'react';
import styles from './LoadMoreFooter.module.css';
export function LoadMoreFooter(props) {
    var message = "Showing top " + (props.showing ? props.showing : 'some') + " items, search to refine your results.";
    return (React.createElement("div", { className: styles.loadMoreBar },
        React.createElement("span", { className: styles.message }, message)));
}
